import React from 'react';
import Search from './components/Search';
import CreateBtn from './components/CreateBtn';
import { CustomerSelect } from './components/CustomerSelect';
import { RestaurantSelect } from './components/RestaurantSelect';
import ResetBtn from './components/ResetBtn';
import SortBy from './components/SortBy/SortBy';
import CountOfItem from './components/CountOfItem';
import WithURLFilters from './components/WithURLFilters';
import style from './ModifierGroupsControlPanel.module.scss';

const ModifierGroupsControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
			</div>
			<div className={style.secondRowWithControls}>
				<div className={style.selectWrapper}>
					<CustomerSelect />
					<RestaurantSelect />
				</div>
				<ResetBtn />
				<div className={style.verticalAlignBlock}>
					<SortBy />
					<CountOfItem />
				</div>
			</div>
		</WithURLFilters>
	);
};

export default ModifierGroupsControlPanel;
